import type { DefaultContext } from '@apollo/client/core';
import { ApolloLink } from '@apollo/client/link/core';

import { accessToken, cacChubSSNId } from './local-cache.config';

export const authMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext((context: DefaultContext) => {
    return {
      headers: {
        ...(context.headers ?? {}), // merge in any headers set directly by individual calls.
        Authorization: `Bearer ${accessToken()}`,
      },
    };
  });

  return forward(operation).map((response) => {
    const accessTokenRef = operation
      .getContext()
      .response.headers.get('access-token') as string;

    if (accessTokenRef) {
      accessToken(accessTokenRef);
    }

    const chubSSNid = operation
      .getContext()
      .response.headers.get('cac-chub-ssid') as string;
    if (chubSSNid) {
      cacChubSSNId(chubSSNid);
    }

    return response;
  });
});
